import type { FeatureFlags } from 'server-schemas/configs';
import { MultiLanguageFeatureFlag, PerLanguageFeatureFlag, SupportedLanguages } from 'server-schemas/configs/feature-flags.types';

let featureFlags: FeatureFlags = {};

export const set = (ff: FeatureFlags) => {
  featureFlags = ff;
};

export const get = (key: keyof FeatureFlags): boolean => <boolean>featureFlags[key] ?? false;

export const getAll = (): FeatureFlags => featureFlags;

export const getFlag = <K extends keyof FeatureFlags>(key: K): FeatureFlags[K] | undefined => (featureFlags as any)[key];

export const getFlagValueByKey = <K extends keyof FeatureFlags>(key: K): boolean => {
  return !!getFlag(key);
};

export const getFlagValueByKeyAndLanguage = <K extends keyof FeatureFlags>(key: K, language: SupportedLanguages): boolean => {
  const featureFlag = getFlag(key);
  if (typeof featureFlag !== 'object') return false;
  if (!featureFlag?.enabled) {
    return false;
  }
  return (featureFlag as MultiLanguageFeatureFlag).languages.includes(language);
};

export const getPerLanguageFlagValue = <K extends keyof FeatureFlags>(key: K, language: SupportedLanguages): boolean => {
  const featureFlag = getFlag(key);
  if (typeof featureFlag !== 'object') return false;
  if (!featureFlag?.enabled) {
    return false;
  }
  return !!(featureFlag as PerLanguageFeatureFlag)[language];
};
